import { captureException } from './SentryService';
import type { LoggerMethods } from './type';

const defaultLoggerMethods: LoggerMethods = {
    error: captureException,
    warn: () => {},
    info: () => {},
    debug: () => {},
    trace: () => {},
};

let customLoggerMethods: LoggerMethods;

export const initCustomLogger = (methods: LoggerMethods): void => {
    if (!customLoggerMethods) {
        customLoggerMethods = methods;
    }
};

export const getLoggerMethods = (): LoggerMethods => {
    if (customLoggerMethods) {
        return customLoggerMethods;
    }
    return defaultLoggerMethods;
};
